import { render, staticRenderFns } from "./list_videos.vue?vue&type=template&id=65524211&scoped=true&lang=pug"
import script from "./list_videos.vue?vue&type=script&lang=js"
export * from "./list_videos.vue?vue&type=script&lang=js"
import style0 from "./list_videos.vue?vue&type=style&index=0&id=65524211&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65524211",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65524211')) {
      api.createRecord('65524211', component.options)
    } else {
      api.reload('65524211', component.options)
    }
    module.hot.accept("./list_videos.vue?vue&type=template&id=65524211&scoped=true&lang=pug", function () {
      api.rerender('65524211', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/help_center/components/list_videos.vue"
export default component.exports